import type { ReactNode } from "react"
import styles from "./Tag.module.css"

// Components/Tags/Tag Small in the design system. Every variant shares the
// geometry and the navy-dark text; only the background changes, which is why
// colour is the sole knob.
export type TagColour =
  | "white"
  | "offWhite"
  | "disabled"
  | "navy"
  | "aqua"
  | "mint"
  | "peach"
  | "lavender"
  | "lemon"

/**
 * A small uppercase tag — a program, a status, a column label.
 *
 * Not a control and not a status region: it announces nothing of its own, so a
 * caller whose tag carries live state is responsible for the `role` and
 * `aria-live` on whatever wraps it.
 */
export function Tag({
  colour = "offWhite",
  className,
  children,
}: {
  colour?: TagColour
  // Extra layout class from the caller (e.g. `flex-shrink`) — the tag owns its
  // own colour and shape, the caller owns where it sits.
  className?: string
  children: ReactNode
}) {
  return (
    <span
      className={`${styles.tag} ${styles[colour]}${className ? ` ${className}` : ""}`}
    >
      {children}
    </span>
  )
}
